import { PAGE_POSITIONS } from 'types';
import type { HeaderCarousel } from 'types/capi/modules';

import Carousel from './Carousel';
import Slide from './Slide';

export type Variant = 'base' | 'small-lg-font' | 'small-md-font';

export type Analytics = {
  id: 'HOMEPAGE_CAROUSEL' | 'PLP_CAROUSEL';
  position: PAGE_POSITIONS;
};

type Props = {
  analytics: Analytics;
  isFullBleed?: boolean;
  module: HeaderCarousel;
  variant: Variant;
};

export default function HeaderCarousel({
  isFullBleed = true,
  module,
  variant = 'base',
  analytics
}: Props) {
  return module.items.length === 1 ? (
    <div className="flex overflow-hidden">
      <Slide
        variant={variant}
        analytics={analytics}
        slide={module.items[0]!}
        index={0}
        isFullBleed={isFullBleed}
      />
    </div>
  ) : (
    <Carousel
      analytics={analytics}
      variant={variant}
      module={module}
      isFullBleed={isFullBleed}
    />
  );
}
